import { highResVideoDimensions } from '../../VideoCallV2/Config/videoInput'

export const videoConfig = {
  width: {
    max: highResVideoDimensions.width,
    ideal: highResVideoDimensions.width,
  },
  height: {
    max: highResVideoDimensions.height,
    ideal: highResVideoDimensions.height,
  },
}

export const audioConfig = { echoCancellation: true }
